<template>
  <b-modal id="modal-request-approval" size="lg" ref="modal" @show="setData" title="Leave Request Approval" :hide-footer="hideButton">
    <form id="form" action="#" autocomplete="off">
      <!-- grid row -->
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Date Range Leave</label>
                <div class="col-md-4 mb-3">
                  <div>
                     {{detail.start}} - {{detail.end}}
                  </div>
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Number of days</label>
                <div class="col-md-9 mb-3">
                  {{detail.day_count}} day
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Leave Type</label>
                <div class="col-md-9 mb-3">
                  {{detail.tipe_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Project</label>
                <div class="col-md-9 mb-3">
                  {{detail.project_abbreviation}} - {{detail.var_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3" >PIC During Leave</label>
                <div class="col-md-9 mb-3">
                  {{detail.contact_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3" >Remarks</label>
                <div class="col-md-9 mb-3">
                  {{detail.reason}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3" >Status</label>
                <div class="col-md-9 mb-3">
                  {{detail.leave_stat_name}}
                </div>
              </div>
              <div class="form-row" v-if="this.detail.attachment_ori !== null && this.detail.attachment_ori !== '' ">
                <label class="col-md-3">File</label>
                <div class="list-group-item" style="cursor:pointer" v-if="imageExt.includes(getExtension(detail.attachment_ori))" @click="downloadFile(detail.attachment_enc, detail.attachment_ori, $event)">
                  <div class="list-group-item-figure">

                    <div class="tile tile-img">
                      <img :src="detail.attachment_enc" alt=""/>
                    </div>
                  </div>
                  <div class="list-group-item-body">
                    <div class="media align-items-center">
                      <div class="media-body">{{detail.attachment_ori}}</div>
                    </div>
                  </div>
                </div>
                <div class="list-group-item" style="cursor:pointer" v-else-if="detail.attachment_ori !== '' "  @click="downloadFile(detail.attachment_enc, detail.attachment_ori, $event)">
                  <div class="list-group-item-figure">
                    <div class="tile tile-circle" >{{detail.attachment_ori.substring(0, 1)}}</div>
                  </div>
                  <div class="list-group-item-body">
                    <h4 class="list-group-item-title">{{detail.attachment_ori}}</h4>
                    <p class="list-group-item-text">{{detail.attachment_ori}}</p>
                  </div>
                </div>
              </div>

              <hr>
              <legend>Approval</legend>
              <template v-if="detail.leave_stat_id !== 0">
                <div class="form-group">
                  <label class="control-label">Approval Information</label>
                  <div class="table-responsive">
                    <table class="table table-hover table-striped" aria-label="Approval Information">
                      <thead>
                      <tr>
                        <th style="min-width:10px" id="level"> Level </th>
                        <th id="name"> Name </th>
                        <th id="email"> Email </th>
                        <th id="status"> Status </th>
                        <th id="date"> Date </th>
                      </tr>
                      </thead>
                      <tbody >
                      <tr v-for="(data, i) in list_supervisor">
                        <td>{{data.level}}</td>
                        <td>{{data.name}}</td>
                        <td>{{data.email}}</td>
                        <td>{{data.status_name}}</td>
                        <td>{{data.status_date}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template>
              <list-supervisor emp_id="" v-else></list-supervisor>
            </div><!-- /.card-body -->
          </div><!-- /.card -->
        </div><!-- /grid column -->
      </div><!-- /grid row -->
    </form>
    <template v-slot:modal-footer >
      <div class="w-100">
        <button class="btn btn-success float-right mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
        <button class="btn btn-danger float-right mr-1" @click="stat_id=5; handleOk($event)"> Reject </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal} from "bootstrap-vue";
import ListSupervisor from "../employee/ListSupervisor";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "LeaveRequestApproval",
  components:{
    ListSupervisor,
    BModal
  },
  data(){
    return{
      stat_id:1,
      detail:{
        attachment_ori:"",
        attachment_enc:""
      },
      list_supervisor:[],
      hideButton:false,
      imageExt:['png', 'jpg', 'jpeg'],
      arr_action:['rejected', 'approved', 'cancelled']
    }
  },
  props:{
    data:{
      type:Object
    }
  },
  methods:{
    handleOk(evt){
      evt.preventDefault()
      let payload = {
        stat_id:this.stat_id,
        emp_id:this.$store.getters.empId,
        trans_id:this.data.trans_id,
        master_id:this.data.master_id,
        log_id:this.data.id
      }

      AxiosCall.Post(payload, urlApi.leave_request.approval).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$refs.modal.hide()
          this.$parent.getData()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          this.getDetail()
        }
      }, 100)
    },
    getDetail(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.leave_request.detail).then(res=>{
        if(res.success){
          this.detail = res.atributes
          this.checkStatus()
          if(this.detail.leave_stat_id !== 0) this.getListSupervisor()
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    checkStatus(){
      this.hideButton =  (this.detail.emp_id == this.$store.getters.empId) && this.arr_action.includes(this.data.action) ? true : false
    },
    getExtension(filename){
      let re = /(?:\.([^.]+))?$/;

      let ext = re.exec(filename)[1];
      return ext
    },
    downloadFile(url, name, evt){
      evt.preventDefault()
      window.open(url, '_blank');
    },
    getListSupervisor(){
      let payload = {
        id:this.detail.id
      }
      AxiosCall.Get(payload, urlApi.leave_request.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
          for (let data of this.list_supervisor){
            if(data.emp_id == this.$store.getters.empId && data.status_name !== null ) {
              this.hideButton = true
              break
            }
          }
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  },
}
</script>